import React, { forwardRef, HTMLAttributes, PropsWithChildren } from 'react';
import Typo from '../Typo';

interface ErrorMessageProps extends HTMLAttributes<HTMLDivElement> {}

const ErrorMessage = forwardRef<
  HTMLDivElement,
  PropsWithChildren<ErrorMessageProps>
>(({ children, ...props }, ref) => {
  return (
    <div ref={ref} {...props}>
      <Typo className="text-red4">{children}</Typo>
    </div>
  );
});

export default ErrorMessage;
